import { render } from "./InputFileUploadCompact.vue?vue&type=template&id=079c1af1&scoped=true"
import script from "./InputFileUploadCompact.vue?vue&type=script&lang=js"
export * from "./InputFileUploadCompact.vue?vue&type=script&lang=js"

import "./InputFileUploadCompact.vue?vue&type=style&index=0&id=079c1af1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-079c1af1"]])

export default __exports__